import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { PotentialPromotionsModule } from '../../potential-promotions/potential-promotions.module';
import { CartCouponModule } from '../cart-coupon/cart-coupon.module';
import { CartSharedModule } from '../cart-shared/cart-shared.module';
import { ShimanoCartTotalsComponent } from './cart-totals.component';
import { SaveCartModalComponent } from './save-cart-modal/save-cart-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    CartSharedModule,
    I18nModule,
    CartCouponModule,
    MatIconModule,
    PotentialPromotionsModule,
    DynamicFormsModule,
    ShimanoCartTotalsComponent,
    SaveCartModalComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartTotalsComponent: {
          component: ShimanoCartTotalsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.Carts,
    }),
  ],
  exports: [ShimanoCartTotalsComponent, SaveCartModalComponent],
})
export class CartTotalsModule {}
